<template>
  <div class="apply-form">
    <div v-if="!isValid" class="text-center">
      <h1>{{ $t('application.appointmentInvalid') }}</h1>
    </div>
    <template v-else>
      <div class="text-center">
        <h1>{{ $t(`application.updateAppointment.${type}`) }}</h1>
      </div>
      <div
        class="apply-form__documents apply-form__section content-box content-box__color-secondary content-box__dense"
      >
        <p>
          {{ $t(`application.updateAppointmentInfo.${type}`) }}
        </p>
        <v-text-field
          flat
          v-model="comment"
          outlined
          hide-details="auto"
          name="comment"
          :label="$t('application.appointmentComment')"
          :readonly="submitting || updated"
        />
      </div>
      <div v-if="!updated" class="d-flex justify-end">
        <v-btn
          @click="submit"
          :loading="submitting"
          color="primary"
          class="ml-md-4 mt-4 mt-md-0 d-md-inline"
        >
          {{ $t('submit') }}
          <v-icon class="ml-4">mdi-send</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { eventBus } from '@/event-bus';

export default {
  data: () => ({
    applicationId: null,
    authToken: null,
    interviewToken: null,
    comment: '',

    submitting: false,
    updated: false
  }),

  props: {
    type: {
      type: Number,
      required: true
    }
  },

  computed: {
    isValid() {
      return this.authToken && this.interviewToken;
    }
  },

  async mounted() {
    this.applicationId = this.$route.params.applicationId;
    this.authToken = this.$route.params.authToken;
    this.interviewToken = this.$route.params.interviewToken;
  },

  methods: {
    ...mapActions('applicationModule', {
      updateAppointment: 'updateAppointment'
    }),

    async submit() {
      this.submitting = true;
      const response = await this.updateAppointment({
        applicationId: this.applicationId,
        authToken: this.authToken,
        interviewToken: this.interviewToken,
        responseType: this.type,
        comment: this.comment
      });

      const result = await response.json();
      if (!result.success) {
        // show error
        eventBus.$emit(
          'errorMessage',
          this.$t('application.appointmentUpdateFailed')
        );
      } else {
        eventBus.$emit(
          'successMessage',
          this.$t('application.appointmentUpdateSuccessful')
        );
        this.updated = true;
      }

      this.submitting = false;
    }
  }
};
</script>
